import axios from "axios";
import { getToken } from "../session";

const POST = async (endpoint, data, options = {}) => {
  const response = await axios.post(endpoint, data, {
    headers: {
      Authorization: `Bearer ${getToken()}`,
      ...(options.headers || {}),
    },
    responseType: options.responseType || "json",
  });
  return response;
};

export default POST;
